import React, { useRef, useState } from 'react';
import emailjs from '@emailjs/browser';
import './Contact.css';

export const Contact = () => {
  const form = useRef();
  const [statusMessage, setStatusMessage] = useState('');
  const [statusClass, setStatusClass] = useState('');

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm('service_04ya0oo', 'template_7r6r2wa', form.current, {
        publicKey: 'ulSu8l2shKdvpcOD3',
      })
      .then(
        () => {
          setStatusMessage('✅ Message sent successfully!');
          setStatusClass('success');
          form.current.reset();
        },
        (error) => {
          setStatusMessage('❌ Failed to send message. Please try again.');
          setStatusClass('error');
          console.error('FAILED...', error.text);
        }
      );
  };

  return (
    <div className="contact-container">
      <h2>Contact Us</h2>
      <form ref={form} onSubmit={sendEmail} className="contact-form">
        <label>Name</label>
        <input type="text" name="name" required />

        <label>Email</label>
        <input type="email" name="email" required />

        <label>Message</label>
        <textarea name="message" rows="5" required />

        <button type="submit">Send Message</button>

        {statusMessage && (
          <p className={`status-message ${statusClass}`}>{statusMessage}</p>
        )}
      </form>
    </div>
  );
};

export default Contact;
